export default "__VITE_ASSET__2a8aae36__"